module.exports = __webpack_public_path__ + "logo-zig-azul.4c729e2acf82f47d4c2530f519958b8f.png";